<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg2"
             ref="statisTitle">
            <span>校本书库统计</span>
        </div>
        <div class="content" :style="contentStyleObj">
            <div id="ebook-statis" style="width:100%;height:100%;position: absolute;"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ebookStatis",
        data () {
            return {
                boxWrapStyleObj: {
                    height: ''
                },
                contentStyleObj: {
                    height: ''
                }
            }
        },
        props: {
            ebookCountList: Array,
            screenHeight:Number,
            titleHeight:Number
        },
        watch: {
            ebookCountList (value) {
                if (value) {
                    this.initChart();
                }
            },
            'screenHeight': 'initBoxHeight',
            'titleHeight': 'initBoxHeight',
        },
        methods: {
            /**
             * 初始化box高度
             */
            initBoxHeight(){
                let winHeight = window.innerHeight;
                if (winHeight < 900) {
                    winHeight = 938;
                }

                let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
                let contentHeight = boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
                // this.boxWrapHeight=boxWrapHeight;
                this.boxWrapStyleObj.height = boxWrapHeight + 'px';
                this.contentStyleObj.height = contentHeight + 'px';
            },
            /**
             * 初始化教师课堂行为柱状图
             */
            initChart () {
                let dataName = [], ebookCount = [],tAssistCount= [];
                this.ebookCountList.filter((item) => {
                    dataName.push(item.subjectname);
                    ebookCount.push(item.ebookCount);
                    tAssistCount.push(item.ebookTeachingCount);
                });

                const option = {
                    color:['#2783CD','#D6F59B'],
                    legend: {
                        data: ['校本教材', '校本教辅'],
                        top:'0',
                        right:'5%',
                        itemWidth:6,
                        itemHeight:6,
                        textStyle:{
                            color:'#708acc'
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'none'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '0%',
                        height:'90%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: dataName,
                            axisLabel: {
                                color: '#708ACC',
                                interval: 0,
                                rotate:40
                            },
                            axisLine: {
                                lineStyle: {
                                    color: '#708ACC',
                                    width: 1,
                                    opacity: 0.3
                                }
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            splitNumber:5,
                            axisLabel: {
                                color: '#708ACC'
                            },
                            axisLine: {
                                show: false
                            },
                            axisTick: {
                                show: false
                            },
                            splitLine: {
                                lineStyle: {
                                    color: '#6076AD',
                                    width: 1,
                                    opacity: 0.3
                                }
                            }
                        }
                    ],
                    series: [
                        {
                            name: '校本教材',
                            type: 'bar',
                            barWidth: '40%',
                            barGap: '8%',
                            data: ebookCount,
                            itemStyle: {
                                normal: {
                                    // 随机显示
                                    //color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}
                                    // 定制显示（按顺序）
                                    // color: function (params) {
                                    //     var colorList = [{
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#2783CD' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#0EFCFF' // 100% 处的颜色
                                    //         }],
                                    //         globalCoord: false // 缺省为 false
                                    //     }, {
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#00A7FC' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#2A4FEA' // 100% 处的颜色
                                    //         }],
                                    //         globalCoord: false // 缺省为 false
                                    //     }, {
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#52CCE2' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#008DFF' // 100% 处的颜色
                                    //         }],
                                    //         globalCoord: false // 缺省为 false
                                    //     }, {
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#67E0E3' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#0181DE' // 100% 处的颜色
                                    //         }],
                                    //         globalCoord: false // 缺省为 false
                                    //     }, {
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#69E7EE' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#2BA8E0' // 100% 处的颜色
                                    //         }],
                                    //         globalCoord: false // 缺省为 false
                                    //     }, {
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#D6F59B' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#42D8CF' // 100% 处的颜色
                                    //         }
                                    //         ]
                                    //     }];
                                    //     // return colorList[params.dataIndex]
                                    //     return colorList[1]
                                    // }
                                    color:'#2673E6'
                                }
                            }
                        },
                        {
                            name: '校本教辅',
                            type: 'bar',
                            barWidth: '30%',
                            barGap: '8%',
                            data: tAssistCount,
                            itemStyle: {
                                normal: {
                                    // 随机显示
                                    //color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}
                                    // 定制显示（按顺序）
                                    // color: function (params) {
                                    //     var colorList = [{
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#2783CD' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#0EFCFF' // 100% 处的颜色
                                    //         }],
                                    //         globalCoord: false // 缺省为 false
                                    //     }, {
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#00A7FC' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#2A4FEA' // 100% 处的颜色
                                    //         }],
                                    //         globalCoord: false // 缺省为 false
                                    //     }, {
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#52CCE2' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#008DFF' // 100% 处的颜色
                                    //         }],
                                    //         globalCoord: false // 缺省为 false
                                    //     }, {
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#67E0E3' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#0181DE' // 100% 处的颜色
                                    //         }],
                                    //         globalCoord: false // 缺省为 false
                                    //     }, {
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#69E7EE' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#2BA8E0' // 100% 处的颜色
                                    //         }],
                                    //         globalCoord: false // 缺省为 false
                                    //     }, {
                                    //         type: 'linear',
                                    //         x: 0,
                                    //         y: 0,
                                    //         x2: 0,
                                    //         y2: 1,
                                    //         colorStops: [{
                                    //             offset: 0, color: '#D6F59B' // 0% 处的颜色
                                    //         }, {
                                    //             offset: 1, color: '#42D8CF' // 100% 处的颜色
                                    //         }
                                    //         ]
                                    //     }];
                                    //     // return colorList[params.dataIndex]
                                    //     return colorList[5]
                                    // }
                                    color:"#28CDE6"
                                }
                            }
                        }
                    ]
                };
                let dataChart = this.$echarts.init(document.getElementById("ebook-statis"));
                dataChart.setOption(option);
                window.addEventListener('resize', function () {
                    dataChart.resize();
                });
            }
        },
        mounted () {
            this.$nextTick(() => {
            })
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../style/databoard";

    .bg2 { 
        background-image : url("../../../assets/images/sydataboard/title-bg.png");
    }
</style>
